import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { PaymentPlan } from 'src/configs/APISchemas/GetQuote';
import { PaymentMsiV2 } from 'src/pages/payment-msi/PaymentMsiV2/PaymentMsiV2';
import { RedirectToCoveragesGuard } from 'src/pages/payment-msi/PaymentMsiV2/guards';
import {
  BuildingDataLoader,
  PaymentPlansLoader,
} from 'src/pages/payment-msi/PaymentMsiV2/loaders';
import {
  BuildingData,
  InterestedParty,
} from 'src/pages/payment-msi/PaymentMsiV2/types';
import {
  getLandlordData,
  mapInterestedPartyToAdditionalInterests,
} from 'src/pages/payment-msi/PaymentMsiV2/utils';
import { updatePurchasePolicyInput } from 'src/redux/actions/purchasePolicy';

export function PaymentMsiV2Loader() {
  const [paymentPlansData, setPaymentPlansData] = useState<PaymentPlan[]>([]);
  const [landlordData, setLandlordData] = useState<InterestedParty | null>(
    null,
  );
  const dispatch = useDispatch();

  function onPaymentPlansLoaded(paymentPlans: PaymentPlan[]) {
    setPaymentPlansData(paymentPlans);
  }

  function onBuildingDataLoaded(buildingData: BuildingData | null) {
    const landlordData = getLandlordData(buildingData);
    setLandlordData(landlordData);

    if (landlordData) {
      dispatch(
        updatePurchasePolicyInput({
          additionalInterests:
            mapInterestedPartyToAdditionalInterests(landlordData),
        }),
      );
    }
  }

  return (
    <PaymentPlansLoader onPaymentPlansLoaded={onPaymentPlansLoaded}>
      <BuildingDataLoader onBuildingDataLoaded={onBuildingDataLoaded}>
        <RedirectToCoveragesGuard>
          <PaymentMsiV2
            paymentPlans={paymentPlansData}
            landlordData={landlordData}
          />
        </RedirectToCoveragesGuard>
      </BuildingDataLoader>
    </PaymentPlansLoader>
  );
}
